import React from "react";
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import { Provider } from 'react-redux';
import models from './models/index';
import { create } from 'dva-core';
import PageWrapper from "./core/PageWrapper";
import PreLoginPage from "./pages/Auth.jsx";
import HangupPage from "./pages/Hangup.jsx";
import WaitingCallPage from "./pages/WaitingCall.jsx";
import "./global.css";

const dvaApp = create();
models.forEach((o) => {
  dvaApp.model(o);
});
dvaApp.start();

const store = dvaApp._store;

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path="/auth" element={<PageWrapper><PreLoginPage /></PageWrapper>} />
          <Route path="/hangup" element={<PageWrapper><HangupPage /></PageWrapper>} />
          <Route path="/waiting" element={<PageWrapper><WaitingCallPage /></PageWrapper>} />
        </Routes>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
